export default __webpack_public_path__ + "static/media/blog-31-image-2.cbf4bdc2.jpg";